if (!customElements.get('product-row-card')) {
  customElements.define(
    'product-row-card',
    class ProductRowCard extends HTMLElement {
      connectedCallback() {
        this.image = this.querySelector('.product-row__media img');
        this.price = this.querySelector('.product-row__price');
        this.variantInput = this.querySelector('input[name="id"]');
        this.addButton = this.querySelector('.product-row__add');
        this.swatches = this.querySelectorAll('.product-row__swatch');

        this.swatches.forEach((swatch) => swatch.addEventListener('click', () => this.select(swatch)));
      }

      select(selected) {
        this.swatches.forEach((swatch) => swatch.setAttribute('aria-pressed', swatch === selected));

        this.variantInput.value = selected.dataset.variantId;
        this.price.innerHTML = selected.dataset.price;

        if (this.image && selected.dataset.image) {
          this.image.removeAttribute('srcset');
          this.image.src = selected.dataset.image;
        }

        const available = selected.dataset.available === 'true';
        this.addButton.disabled = !available;
        this.addButton.removeAttribute('aria-disabled');
        this.addButton.querySelector('span').textContent = available
          ? this.addButton.dataset.addLabel
          : this.addButton.dataset.soldOutLabel;
      }
    }
  );
}
